import { useQuery } from '@tanstack/react-query';
import type { PosterOverview } from '@teentack/shared';
import { fetchPosterOverview } from './poster.api';

export const posterKeys = { overview: ['poster', 'overview'] as const };

export function usePosterOverview(enabled = true) {
  return useQuery<PosterOverview>({
    queryKey: posterKeys.overview,
    queryFn: fetchPosterOverview,
    enabled,
    staleTime: 15_000,
  });
}
